import { ValidationCode } from './constants';
import { FieldError } from 'react-hook-form';
import { CalendarEvent } from '@src/types/Events';
import moment from 'moment';
import { EventMountArg } from '@fullcalendar/core';

const MINUTES_PER_HOUR = 60;
const TIME_PAD_LENGTH = 2;
const TIME_PAD_CHAR = '0';

export const normalizeStackId = (stackId?: string | null): string | null => {
  if (!stackId) {
    return null;
  }
  const trimmed = stackId.trim();
  return trimmed === '' ? null : trimmed;
};

export const calculateEventDuration = (start: string, end: string): string => {
  const diffInMinutes = moment(end).diff(moment(start), 'minutes');
  const hours = Math.floor(diffInMinutes / MINUTES_PER_HOUR);
  const minutes = diffInMinutes % MINUTES_PER_HOUR;
  return `${hours.toString().padStart(TIME_PAD_LENGTH, TIME_PAD_CHAR)}:${minutes.toString().padStart(TIME_PAD_LENGTH, TIME_PAD_CHAR)}:00`;
};

const normalizeRrule = (
  rrule: CalendarEvent['rrule'],
  startDate: string,
): CalendarEvent['rrule'] => {
  if (!rrule?.freq) {
    return null;
  }
  return {
    ...rrule,
    dtstart: startDate,
    until: rrule.until || null,
  };
};

export const normalizeEventForSubmission = (
  data: CalendarEvent,
): CalendarEvent => {
  return {
    title: data.title,
    start: moment.utc(data.start).toISOString(),
    end: moment.utc(data.end).toISOString(),
    duration: calculateEventDuration(data.start, data.end),
    stackId: normalizeStackId(data.stackId),
    startCommands: data.startCommands || [],
    stopCommands: data.stopCommands || [],
    backgroundColor: data.backgroundColor,
    rrule: normalizeRrule(data.rrule, data.start),
  };
};

export const hasErrorCode = (
  error: FieldError | undefined,
  code: ValidationCode,
): error is FieldError => {
  if (!error) {
    return false;
  }
  return error.type === code;
};

export const getErrorMessage = (error: FieldError | undefined): string => {
  return error?.message ?? '';
};

export function applyEventStyling(info: EventMountArg): void {
  const bgColor = info.event.backgroundColor;
  info.el.style.backgroundColor = bgColor;
  info.el.style.setProperty('--event-color', bgColor);
}
